<template>
    <div>
        <!-- <v-row no-gutters>
            <v-col :cols="12">
                <h1 class="headline font-weight-light mb-3">
                    Setting / Reset Password
                </h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="6" md="5">
                <v-card>
                    <div class="pa-5">
                        <v-text-field :label="nameF" disabled></v-text-field>
                    </div>
                    <div class="pa-5 mar-t-30">
                        <v-text-field
                            v-model="password"
                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show1 ? 'text' : 'password'"
                            name="input-10-1"
                            label="Password"
                            counter
                            @click:append="show1 = !show1"
                        ></v-text-field>
                    </div>
                    <div class="pa-5 mar-t-30">
                        <v-btn
                            block
                            color="success"
                            @click="reset_password()"
                            :disabled="password === ''"
                        >
                            Reset Password</v-btn
                        >
                    </div>
                </v-card>
            </v-col>
        </v-row>
        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div> -->

        <v-card max-width="434" tile>
            <v-img
                height="100%"
                src="../../assets/all/acacia-building.jpg"
            ></v-img>
            <v-col cols="6">
                <v-avatar size="100" style="position: absolute; top: 90px">
                    <!-- <v-img
                        src="https://cdn.vuetifyjs.com/images/profiles/marcus.jpg"
                    ></v-img> -->
                    <img :src="url_pic + member.img" :alt="member.name" />
                </v-avatar>
            </v-col>
            <v-list-item color="rgba(0, 0, 0, .4)" class="">
                <v-list-item-content>
                    <v-row>
                        <v-col cols="8" class="d-none d-sm-block">
                            <v-list-item-title class="title">
                                {{ member.name }}
                            </v-list-item-title>
                            <v-list-item-subtitle>{{
                                member.team
                            }}</v-list-item-subtitle>
                        </v-col>
                        <v-col cols="8" class="d-sm-none mt-10">
                            <v-list-item-title class="title">
                                {{ member.name }}
                            </v-list-item-title>
                            <v-list-item-subtitle>{{
                                member.team
                            }}</v-list-item-subtitle>
                        </v-col>
                        <v-col cols="4" class="text-right">
                            <v-btn
                                x-small
                                fab
                                @click="change_edit(1)"
                                class="mr-1"
                            >
                                <v-icon>mdi-camera</v-icon>
                            </v-btn>
                            <v-btn x-small fab @click="change_edit(2)">
                                <v-icon>mdi-account-key</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-list-item-content>
            </v-list-item>

            <div v-if="edit_img == true">
                <v-row class="justify-center">
                    <v-col cols="6">
                        <vue-upload-multiple-image
                            @upload-success="uploadImageSuccess"
                            @before-remove="beforeRemove"
                            @edit-image="editImage"
                            @data-change="dataChange"
                            dragText="UPLOAD"
                            browseText="Profile"
                            primaryText="profile image"
                            markIsPrimaryText="จัดลำดับรูปภาพ"
                            idUpload="myIdUpload1"
                            editUpload="myIdEdit1"
                            :maxImage="1"
                        ></vue-upload-multiple-image>
                    </v-col>
                    <v-col cols="8">
                        <v-progress-linear
                            v-if="chk_save_data_img == true"
                            indeterminate
                            color="cyan"
                        ></v-progress-linear>
                        <v-btn
                            v-if="chk_save_data_img == false"
                            block
                            :disabled="img.length == 0"
                            color="success"
                            @click="upload_profile()"
                        >
                            upload profile</v-btn
                        >
                    </v-col>
                </v-row>
            </div>

            <div v-if="edit_pass == true" class="mt-5">
                <div class="pa-5 mar-t-30">
                    <!-- <v-text-field
                        v-model="password"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show1 ? 'text' : 'password'"
                        name="input-10-1"
                        label="New Password"
                        counter
                        @click:append="show1 = !show1"
                    ></v-text-field> -->
                    <div class="input_container">
                        <ul>
                            <li
                                v-bind:class="{
                                    is_valid: contains_eight_characters,
                                }"
                            >
                                Digit อย่างน้อย 8 ตัวขึ้นไป
                            </li>
                            <li
                                v-bind:class="{
                                    is_valid: contains_number,
                                }"
                            >
                                ตัวเลข อย่างน้อย 1 ตัว
                            </li>
                            <li
                                v-bind:class="{
                                    is_valid: contains_uppercase,
                                }"
                            >
                                ตัวอักษรพิมพ์ใหญ่ อย่างน้อย 1 ตัว
                            </li>
                            <li
                                v-bind:class="{
                                    is_valid: contains_special_character,
                                }"
                            >
                                ตัวอักขระพิเศษ อย่างน้อย 1 ตัว
                            </li>
                        </ul>
                        <small class="indigo--text"
                            >*อ้างอิงจากประกาศนโยบายด้านความปลอดภัยของข้อมูลสารสนเทศ</small
                        >
                        <div
                            class="checkmark_container"
                            v-bind:class="{ show_checkmark: valid_password }"
                        >
                            <svg width="50%" height="50%" viewBox="0 0 140 100">
                                <path
                                    class="checkmark"
                                    v-bind:class="{ checked: valid_password }"
                                    d="M10,50 l25,40 l95,-70"
                                />
                            </svg>
                        </div>

                        <v-text-field
                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="show1 = !show1"
                            :type="show1 ? 'text' : 'password'"
                            @input="checkPassword"
                            v-model="password"
                            autocomplete="off"
                            placeholder="New Password"
                            counter
                        />
                        <v-text-field
                            class="mar-t-10"
                            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="show2 = !show2"
                            :type="show2 ? 'text' : 'password'"
                            @input="checkPassword2"
                            v-model="password2"
                            autocomplete="off"
                            placeholder="Confirm New Password"
                            counter
                        />
                    </div>
                </div>
                <div class="pa-5 mar-t-30">
                    <v-btn
                        block
                        color="success"
                        @click="reset_password()"
                        :disabled="
                            password2 == false || valid_password2 == false
                        "
                    >
                        Save Password</v-btn
                    >
                </div>
            </div>
        </v-card>

        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>

        <div class="mt-5" v-if="edit_img == true">
            <span class="body-1 text-color-red"
                >หลังจากอัพรูปโปรไฟล์ใหม่แล้ว ถ้ารูปในระบบยังไม่เปลี่ยน ให้
                Clear Cache ของ Browser และ Refresh เข้าระบบใหม่ครับ</span
            >
        </div>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
import VueUploadMultipleImage from "vue-upload-multiple-image"
import resizebase64 from "resize-base64"

let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    components: {
        VueUploadMultipleImage,
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        // console.log(localStorage)
    },
    computed: {
        ...mapState(["snackbar"]),
        ...mapState(["isLoading"]),
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateIsLoading"]),
        async reset_password() {
            let pass = {
                password: this.password,
            }
            this.mutateIsLoading()
            await axios
                .post(url + "changepassword", pass, this.tk)
                .then((response) => {
                    this.mutatesnackbar()
                    this.clear_state()
                    this.mutateIsLoading()

                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        uploadImageSuccess(formData, index, fileList) {
            // console.log("data", formData, index, fileList)

            this.img = fileList
        },
        beforeRemove(index, done, fileList) {
            var r = confirm("remove image")
            if (r == true) {
                done()
            } else {
            }
        },
        editImage(formData, index, fileList) {
            // console.log("edit data", formData, index, fileList)
        },
        dataChange() {},
        change_edit(st) {
            if (st == 1) {
                this.edit_img = !this.edit_img
                this.edit_pass = false
            } else if (st == 2) {
                this.edit_pass = !this.edit_pass
                this.edit_img = false
            }
        },
        async upload_profile() {
            // console.log(this.img)
            this.chk_save_data_img = true

            let formData = new FormData()

            if (undefined !== this.img && this.img.length) {
                for (let i = 0; i < this.img.length; i++) {
                    let img_pro = resizebase64(this.img[i].path, 500, 500)
                    formData.append(`img[${i}]`, img_pro)
                }
            }

            //Save Img
            await axios
                .post(url + "change-profile", formData, this.tk)
                .then((response) => {
                    // console.log(response)
                    // console.log(localStorage.emp_img)
                    this.chk_save_data_img = false
                    location.reload()
                })
                .catch(function(error) {
                    console.log(error, "-- upload img error")
                    this.$swal({
                        text: "ปิดงานไม่สำเร็จ รบกวนติดต่อ Programmer Team !",
                        icon: "warning",
                        button: true,
                    })
                })
        },
        checkPassword() {
            this.password_length = this.password.length
            const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/

            if (this.password_length > 7) {
                this.contains_eight_characters = true
            } else {
                this.contains_eight_characters = false
            }

            this.contains_number = /\d/.test(this.password)
            this.contains_uppercase = /[A-Z]/.test(this.password)
            this.contains_special_character = format.test(this.password)

            if (
                this.contains_eight_characters === true &&
                this.contains_special_character === true &&
                this.contains_uppercase === true &&
                this.contains_number === true
            ) {
                this.valid_password = true
            } else {
                this.valid_password = false
            }
        },
        checkPassword2() {
            this.password_length = this.password.length
            const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/

            if (this.password_length > 7) {
                this.contains_eight_characters = true
            } else {
                this.contains_eight_characters = false
            }

            this.contains_number = /\d/.test(this.password)
            this.contains_uppercase = /[A-Z]/.test(this.password)
            this.contains_special_character = format.test(this.password)

            if (
                this.contains_eight_characters === true &&
                this.contains_special_character === true &&
                this.contains_uppercase === true &&
                this.contains_number === true
            ) {
                if (this.password == this.password2) {
                    this.valid_password2 = true
                } else {
                    this.valid_password2 = false
                }
            } else {
                this.valid_password2 = false
            }
        },
        clear_state() {
            this.password = null
            this.password2 = null
            this.password_length = 0
            this.contains_eight_characters = false
            this.contains_number = false
            this.contains_uppercase = false
            this.contains_special_character = false
            this.valid_password = false
            this.valid_password2 = false
            this.show1 = false
            this.how2 = false

            this.edit_pass = false
            this.edit_img = false
        },
    },
    data() {
        return {
            nameF: localStorage.fullname,
            show1: false,
            edit_pass: false,
            edit_img: false,
            chk_save_data_img: false,
            tk: "",
            text: "Success, Your work has been saved",
            img: [],
            member: {
                name: localStorage.fullname,
                team: localStorage.team_name,
                img: localStorage.emp_img,
            },
            url_pic: `${process.env.VUE_APP_ROOT_API}/api/profile_img/`,
            password: null,
            password2: null,
            password_length: 0,
            contains_eight_characters: false,
            contains_number: false,
            contains_uppercase: false,
            contains_special_character: false,
            valid_password: false,
            valid_password2: false,
            show1: false,
            show2: false,
        }
    },
}
</script>
<style scoped>
ul {
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

li {
    margin-bottom: 8px;
    color: #525f7f;
    position: relative;
}

li:before {
    content: "";
    width: 0%;
    height: 2px;
    background: #2ecc71;
    position: absolute;
    left: 0;
    top: 50%;
    display: block;
    transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.input_container {
    position: relative;
}

input[type="password"] {
    line-height: 1.5;
    display: block;
    color: rgba(136, 152, 170, 1);
    font-weight: 300;
    width: 100%;
    height: calc(2.75rem + 2px);
    padding: 0.625rem 0.75rem;
    border-radius: 0.25rem;
    background-color: #fff;
    transition: border-color 0.4s ease;
    border: 1px solid #cad1d7;
    outline: 0;
}

input[type="password"]:focus {
    border-color: rgba(50, 151, 211, 0.45);
}

/* Checkmark  */

.is_valid {
    color: rgba(136, 152, 170, 0.8);
}
.is_valid:before {
    width: 100%;
}

.checkmark_container {
    border-radius: 50%;
    position: absolute;
    top: -15px;
    right: -5px;
    background: #2ecc71;
    width: 30px;
    height: 30px;
    visibility: hidden;
    opacity: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity 0.4s ease;
}

.show_checkmark {
    visibility: visible;
    opacity: 1;
}

.checkmark {
    width: 100%;
    height: 100%;
    fill: none;
    stroke: white;
    stroke-width: 15;
    stroke-linecap: round;
    stroke-dasharray: 180;
    stroke-dashoffset: 180;
}

.checked {
    animation: draw 0.5s ease forwards;
}

@keyframes draw {
    to {
        stroke-dashoffset: 0;
    }
}
</style>
